export default {"src":"/_next/static/media/logo-bandits.9bc83abb.svg","height":75,"width":176,"blurWidth":0,"blurHeight":0};